export const safeCastNumber = (value?: number | null) => Number(value || 0);
